const adr = location.pathname.split('/')[1];

const active_nav = document.querySelector(`#nav-item-${adr}`)
if (active_nav) {
    active_nav.querySelector('a').classList.add('active');
}
